module.exports = __webpack_public_path__ + "img/instagram_black.309ba708.png";